module.exports = __webpack_public_path__ + "img/bzhan.da2c6fd5.png";